import { render } from "./TutorialsPage.vue?vue&type=template&id=a1908cbe&ts=true"
import script from "./TutorialsPage.vue?vue&type=script&lang=ts"
export * from "./TutorialsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__